
import { Component, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { AnalysisRequest, SampleBatch, AnalysisRequestSubject } from '@/modules/analysis/models/analysisRequest';
import * as AnalysisRequestService from '@/modules/analysis/services/analysisRequestService';
import AnalysisSubject from '@/modules/analysis/components/create-request/AnalysisSubject.vue';
import AnalysisSampleList from '@/modules/analysis/components/create-request/AnalysisSampleList.vue';

@Component({
  components: { AnalysisSubject, AnalysisSampleList }
})
export default class NewAnalysis extends Vue {
  @State((state) => state.analysis.newRequest)
  protected newRequest!: AnalysisRequest;
  @Mutation('analysis/resetNewRequest')
  protected resetNewRequest!: () => Promise<void>;
  @Mutation('analysis/setNewRequestSubject')
  protected setNewRequestSubject!: (subject: AnalysisRequestSubject) => Promise<void>;
  @Mutation('analysis/addBatchToNewRequest')
  protected addBatchToNewRequest!: (batch: SampleBatch) => Promise<void>;
  @Mutation('analysis/editBatchToNewRequest')
  protected editBatchToNewRequest!: (batchParam: { index: number; sample: SampleBatch }) => Promise<void>;
  @Mutation('analysis/deleteBatchToNewRequest')
  protected deleteBatchToNewRequest!: (index: number) => Promise<void>;
  protected valid = true;
  protected sendingRequest = false;
  protected requestSent = false;
  protected requestError = false;
  protected emptyBatchError = false;
  protected displaySubjectError = false;

  /**
   * Validate and send form to backend to create new request for analysis
   */
  protected validate(): void {
    if (!this.newRequest.subject.locationId || !this.newRequest.subject.budgetLineId) {
      this.displaySubjectError = true;
    } else {
      this.displaySubjectError = false;
    }
    const isValid = (this.$refs.form as HTMLFormElement).validate();
    if (isValid && !this.displaySubjectError && this.newRequest.sampleBatches.length > 0) {
      this.requestError = false;
      this.emptyBatchError = false;
      this.sendingRequest = true;
      setTimeout(() => {
        AnalysisRequestService.create(this.newRequest)
          .then(() => (this.requestSent = true))
          .catch(() => (this.requestError = true))
          .finally(() => {
            this.sendingRequest = false;
          });
      }, 1000);
    } else if (this.newRequest.sampleBatches.length === 0) {
      this.emptyBatchError = true;
    }
  }

  protected resetForm(): void {
    (this.$refs.form as HTMLFormElement).reset();
    this.resetNewRequest();
    this.requestSent = false;
    this.displaySubjectError = false;
  }

  protected destroyed(): void {
    if (this.requestSent === true) {
      this.resetNewRequest();
    }
  }
}
